import React from "react";

import { GroupRow, Column } from "./styles";
import { TextFieldControl } from "components/FormControl";
import { lengthValidator } from "utils/validators";
import SimpleField from "components/SimpleField";
import QuestionControl from "./QuestionControl/QuestionControl";

type QuestionValues = {
  title: string;
  code: string;
  complement: string;
  isRequired: "true" | "false";
};

interface Props {
  isEditMode: boolean;
  triviaId: number | null;
  isNewTrivia: boolean;
  displayValues: any;
  onQuestionSubmit: (values: QuestionValues) => Promise<void>;
}

const Form = ({
  isEditMode,
  triviaId,
  isNewTrivia,
  displayValues,
  onQuestionSubmit,
}: Props) => {
  return (
    <>
      <GroupRow>
        <Column>
          {isEditMode ? (
            <TextFieldControl
              variant="outlined"
              margin="none"
              name="title"
              label="Title"
              validate={lengthValidator(100)}
              fullWidth
              required
            />
          ) : (
            <SimpleField label="Title" value={displayValues?.title} />
          )}
        </Column>
        <Column>
          {isEditMode ? (
            <TextFieldControl
              variant="outlined"
              margin="none"
              name="code"
              label="Code"
              validate={lengthValidator(100)}
              fullWidth
              required
            />
          ) : (
            <SimpleField label="Code" value={displayValues?.code} />
          )}
        </Column>
      </GroupRow>
      {!isNewTrivia && (
        <GroupRow>
          <Column>
            <QuestionControl
              questions={displayValues?.questions}
              name="questions"
              triviaId={triviaId}
              onSubmit={onQuestionSubmit}
              isEditMode={isEditMode}
            />
          </Column>
        </GroupRow>
      )}
    </>
  );
};

export default Form;
